<template>
  <ul
    role="list"
    class="-mb-8 "
  >
    <component
      :is="isSortable ? 'mia-draggable' : 'div'"
      :list="sortedLeads"
      :class="isWall ? 'grid grid-cols-3' : ''"
      ghost-class="ghost"
      handle=".handle"
      @change="onSortChange"
    >
      <mia-timeline-item
        v-for="(lead, index) in calcedLeadsForPages"
        :key="lead.id"
        class="px-2 historyNode"
        :is-last="index + 1 === calcedLeadsForPages.length"
        :is-connected="isTimeline"
        v-bind="$attrs"
        :card-classes="{
          'border-l-2 border-orange-500': parseInt(searchedUser) === parseInt(lead.item_account_manager),
          'border-l-2 border-purple-500': parseInt(searchedUser) !== parseInt(lead.item_account_manager) && (parseInt(searchedUser) === parseInt(lead.item_absent_substitute)),
          'bg-green-50 bg-opacity-50 border-l-4 border-green-400': shouldHighlightGreen(lead),
          'bg-red-50 bg-opacity-50 border-l-4 border-red-400': shouldHighlightRed(lead),
          'bg-white': !shouldHighlightGreen(lead) && !shouldHighlightRed(lead),
          'hover:shadow-md': true,
          'opacity-50 border-gray-500 border-2': lead.item_assigned_automaticly === '1' && isLeadpool
        }"
        :draggable="lead.item_lead_type_is_process === '0' && lead.item_lead_type_is_task === '0'"
        :data-lead-id="lead.id"
        v-on="$listeners"
        @click="onLeadClick(lead)"
      >
        <mia-sparkling-diamond
          v-if="lead.item_lead_type_is_process === '1' && showDiamond"
          v-tooltip="{ placement: 'left', offset: 10, content: lead.item_lead_type_title }"
          class="absolute top-0 left-0 -ml-12"
          @click="toggleProcess(lead)"
        />
        <div
          class="absolute top-0 right-0"
          style="margin-top: -0.7rem; margin-right: -0.7rem;"
        >
          <input
            v-if="hasMultiSelection"
            type="checkbox"
            class="w-6 h-6 shadow-md"
            :checked="multiSelection.includes(lead.id)"
            @change="toggleMultiSelection(lead)"
            @click.stop
          >
          <button
            v-else
            v-tooltip="showActionsMenu === lead.id ? '' : 'Aktionen'"
            type="button"
            class="border border-gray-300 rounded-full shadow-md inline-flex items-center justify-center focus:outline-none"
            :class="showActionsMenu === lead.id ? 'bg-orange-mia text-white' : 'bg-gray-200 relative text-gray-900 hover:bg-orange-mia hover:text-white'"
            style="width: 1.75rem; height: 1.75rem;"
            @click.stop="showActionsMenu = showActionsMenu === lead.id ? null : lead.id"
          >
            <mia-streamline-icon
              class="w-4 h-4 fill-current"
              src="navigation-menu-horizontal"
            />

            <transition
              enter-class="opacity-0 transform -translate-y-4"
              enter-active-class="transition-all duration-150 ease-out"
              enter-to-class="opacity-100 transform translate-y-0"
              leave-class="opacity-100 transform translate-y-0"
              leave-active-class="transition-all duration-150 ease-out"
              leave-to-class="opacity-0 transform -translate-y-2"
            >
              <div
                v-if="showActionsMenu === lead.id"
                v-click-outside="() => showActionsMenu = null"
                class="absolute right-0 top-0 mr-1 rounded bg-gray-100 border border-gray-300 shadow-md w-56 text-left z-10 overflow-hidden divide-y divide-gray-300"
                style="margin-top: 2rem"
              >
                <button
                  class="px-3 py-2 flex items-center hover:bg-red-600 hover:text-white w-full text-gray-900 focus:outline-none"
                  @click.stop="handleDeleteLead(lead.id)"
                >
                  <mia-streamline-icon
                    class="w-4 h-4 mr-2 fill-current"
                    src="bin-1"
                  />
                  <span>{{ isAllowed('leadadmin') || isAllowed('delete_leads') ? 'Eintrag löschen' : 'Löschen anfragen' }}</span>
                </button>
                <button
                  class="px-3 py-2 flex items-center hover:bg-orange-mia hover:text-white w-full text-gray-900 focus:outline-none"
                  @click.stop="startMultiSelection(lead)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="w-4 h-4 mr-2"
                  ><path d="m12 15 2 2 4-4" /><rect
                    width="14"
                    height="14"
                    x="8"
                    y="8"
                    rx="2"
                    ry="2"
                  /><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" /></svg>
                  <span>Mehrfachauswahl</span>
                </button>
              </div>
            </transition>
          </button>
        </div>
        <div
          v-if="(lead.item_is_placeholder === '1')"
          v-tooltip="'Platzhalter'"
          class="absolute z-10 p-2 -mt-8 text-white rounded-full shadow-lg left-0-top-0"
          :class="'bg-yellow-500'"
          style="margin-left: -2.25rem;"
        >
          <mia-streamline-icon
            src="time-clock-circle-1"
            class="w-5 h-5 fill-current"
          />
        </div>
        <div
          v-if="(lead.item_show_is_won !== '1') && (lead.item_lead_type_is_task === '1' || lead.item_is_done === '1')"
          v-tooltip="lead.item_is_done === '1' ? 'Abgeschlossen' : 'abschließen'"
          class="absolute z-10 p-2 -mt-8 text-white rounded-full shadow-lg left-0-top-0"
          :class="lead.item_is_done === '1' ? 'bg-green-500' : 'bg-gray-500'"
          style="margin-left: -2.25rem;"
          @click="lead.item_is_done === '1' ? null : handleFinishTaskLead(lead.id)"
        >
          <mia-streamline-icon
            src="check-circle-1"
            class="w-5 h-5 fill-current"
          />
        </div>
        <div
          v-if="(lead.item_lead_type_is_process === '1' || lead.item_lead_type_ends_process === '1' || lead.item_show_is_won === '1') && lead.item_is_done === '1' && lead.item_lead_type_is_won === '1'"
          v-tooltip="'Abgeschlossen (gewonnen)'"
          class="absolute z-10 p-2 -mt-8 text-white bg-green-500 rounded-full shadow-lg left-0-top-0"
          style="margin-left: -2.25rem;"
        >
          <mia-streamline-icon
            src="check-circle-1"
            class="w-5 h-5 fill-current"
          />
        </div>
        <div
          v-else-if="(lead.item_lead_type_is_process === '1' || lead.item_lead_type_ends_process === '1' || lead.item_show_is_won === '1') && lead.item_is_done === '1' && lead.item_lead_type_is_won === '0'"
          v-tooltip="'Abgeschlossen (verloren)'"
          class="absolute z-10 p-2 -mt-8 text-white bg-red-500 rounded-full shadow-lg left-0-top-0"
          style="margin-left: -2.25rem;"
        >
          <mia-streamline-icon
            src="remove-circle"
            class="w-5 h-5 fill-current"
          />
        </div>
        <div
          v-if="lead.item_seen_at === null"
          class="absolute top-0 right-0 z-10 w-2 h-2 mt-4 mr-4 bg-red-600 rounded-full"
        />
        <div
          class="relative w-full handle"
        >
          <div
            class="relative flex flex-wrap items-start space-x-3"
            :class="lead.item_lead_type == 7 ? 'flex-row-reverse text-right' : 'flex-row'"
          >
            <div
              v-if="lead.item_user_id"
              class="relative"
            >
              <div
                class="flex items-center justify-center w-10 h-10 overflow-hidden bg-gray-400 rounded-full ring-8 ring-white"
              >
                <img
                  class="w-full"
                  :src="lead.item_image"
                  alt=""
                >
              </div>                        <span class="absolute bottom-0 right-0 -mr-1 -mb-1 bg-white rounded-tl px-0.5 py-px">                        <!-- Heroicon name: solid/chat-alt -->
                <svg
                  class="w-5 h-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z"
                    clip-rule="evenodd"
                  />
                </svg>
              </span>
            </div>
            <div
              v-else
              class="relative px-1"
            >
              <div
                class="relative flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full ring-8 ring-white"
              >
                <!-- Heroicon name: solid/user-circle -->
                <svg
                  class="w-5 h-5 text-gray-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <div class="flex-1 min-w-0">
              <div>
                <div class="flex items-center text-sm">
                  <div
                    v-if="false"
                    class="flex items-center"
                  >
                    <mia-lazy-select
                      v-if="lead.item_is_customer_notice !== '1'"
                      v-model="selectedUser"
                      :label="(value) => value.label"
                      name="item_user_id"
                      :options="searchUserResults"
                      @search="searchUser"
                    />
                    <div
                      class="flex items-center justify-center w-8 h-8 ml-2 bg-green-300 rounded hover:bg-green-400"
                      @click="assignLeadUser"
                    >
                      <i class="fa fa-check" />
                    </div>
                    <div
                      class="flex items-center justify-center w-8 h-8 ml-1 bg-red-300 rounded hover:bg-red-400"
                      @click="disableEdit"
                    >
                      <i class="fa fa-times" />
                    </div>
                  </div>
                  <div
                    v-else
                    class="flex items-center justify-between w-full"
                  >
                    <div class="flex items-center w-full">
                      <span class="py-2">{{ lead.item_firstname }} {{ lead.item_lastname }}</span>
                      <div
                        v-if="lead.item_is_customer_notice !== '1'"
                        @click="enableEdit(lead.id)"
                      >
                        <i class="ml-2 fa fa-edit" />
                      </div>
                      <div class="flex flex-wrap flex-1 justify-end">
                        <p
                          v-if="lead.item_custom_sleeptime"
                          class="flex justify-between mb-0 text-sm text-orange-400"
                        >
                          <span>{{ lead.item_custom_sleeptime | datetime }}</span>
                        </p>
                        <p
                          v-else
                          class="mt-0.5 text-sm text-gray-500 justify-between flex mb-0"
                        >
                          <span>{{ lead.item_created_at | datetime }}</span>
                        </p>
                        <p
                          v-if="lead.item_lead_type_is_process === '0' && lead.item_is_customer_notice !== '1' && lead.item_escalates_at && lead.item_is_done !== '1'"
                          class="flex justify-between text-sm text-red-400 ml-2"
                        >
                          <span>{{ lead.item_escalates_at | datetime }}</span>
                        </p>
                      </div>
                    </div>
                    <button
                      v-if="showConversion && lead.item_children_count <= 1 && lead.item_lead_type_is_task !== '1'"
                      v-tooltip="lead.item_lead_type_is_process === '1' ? 'In Lead umwandeln' : 'In Vorgang umwandeln'"
                      class="w-6 h-6"
                      @click="handleConversion(lead)"
                    >
                      <i class="fa fa-exchange" />
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-if="showCustomerLink"
                class="mt-1.5 mb-2 text-sm text-gray-700 flex items-center justify-between"
              >
                <div
                  v-if="lead.item_customer_id"
                  class="flex"
                >
                  <a
                    :href="'/customers/'+lead.item_customer_id+'/leads'"
                  >
                    {{ lead.item_customer_company ? lead.item_customer_company : lead.item_customer_firstname +' '+ lead.item_customer_lastname }}
                  </a>
                  <a
                    class="ml-2"
                    target="_blank"
                    :href="'/customers/'+lead.item_customer_id+'/leads'"
                  ><mia-streamline-icon
                    class="w-3 h-3 fill-current"
                    src="share-external"
                  /></a>
                </div>
                <span class="flex justify-end text-xs text-gray-500">{{ lead.item_parent_alt_title !== null ? lead.item_parent_alt_title : lead.item_parent_lead_type !== null ? lead.item_parent_lead_type : lead.item_alt_title }}</span>
              </div>
              <div
                v-if="showNote"
                class="mt-2 mb-4 text-sm text-gray-700"
              >
                <p
                  v-html="lead.item_note"
                />
                <div
                  v-if="lead.item_lead_type_is_process === '0' && index === 0"
                  class="flex flex-wrap -mx-2"
                >
                  <div class="w-full mx-2 font-bold">
                    Mögliche Folgeleads:
                  </div>
                  <button
                    v-for="followup in lead.item_lead_type_followup"
                    :key="followup.id"
                    class="rounded-full m-2 shadow p-2"
                    @click="toggleLeadCreate(followup.id, lead.item_parent_lead)"
                  >
                    {{ followup.title }}
                  </button>
                </div>
              </div>
            </div>
            <div
              class="flex w-full flex-nowrap"
              :class="lead.item_is_customer_notice === '1' ? 'flex-row-reverse' : 'flex-row'"
            >
              <a
                href="#"
                :style="'background: '+ lead.item_color +';'"
                class="relative inline-flex items-center h-6 px-2 text-xs leading-3 bg-white border border-gray-300 rounded-full"
                :class="lead.item_is_customer_notice === '1' ? 'ml-6' : 'mr-2'"
              >
                <span
                  v-tooltip="lead.item_note"

                  class="leadTypeTag ml-3.5 font-medium text-gray-900"
                >
                  {{ lead.item_lead_type_title }}{{ lead.item_parent_progress_title ? " : "+lead.item_parent_progress_title : "" }}
                </span>
              </a>
              <a
                v-if="lead.item_saleschannel_title"
                href="#"
                :style="'background: '+ lead.item_color +';'"
                class="relative inline-flex items-center h-6 px-2 text-xs leading-3 bg-white border border-gray-300 rounded-full"
                :class="lead.item_is_customer_notice === '1' ? 'ml-6' : 'mr-2'"
              >
                <span
                  v-tooltip="lead.item_note"

                  class="leadTypeTag ml-3.5 font-medium text-gray-900"
                >
                  {{ lead.item_saleschannel_title }}
                </span>
              </a>
              <hr class="w-full my-2">
            </div>
            <div
              v-if="lead.item_lead_type_is_process === '0' && lead.item_meta && availableSalesChannels"
              class="flex w-full -mx-2 text-sm flex-wrap"
            >
              <div
                v-if="lead.item_is_placeholder"
                class="flex px-2 pt-3 text-xs flex-nowrap"
              >
                <a
                  target="_blank"
                  :href="'/lead/mails/' + lead.id + (lead.item_is_placeholder === '1' ? '/placeholder' : '')"
                >Email öffnen</a>
              </div>
              <div
                v-for="meta in lead.item_meta.customerIdentifier"
                :key="meta"
                class="flex px-2 pt-3 text-xs flex-nowrap"
              >
                <span>Kunden-Identifier:</span>
                <span class="ml-1">
                  {{ meta }}
                </span>
              </div>
              <div
                v-for="meta in lead.item_meta.offerIdentifier"
                :key="meta"
                class="flex px-2 pt-3 text-xs flex-nowrap"
              >
                <span>Angebots-Identifier:</span>
                <span class="ml-1">
                  {{ meta }}
                </span>
              </div>
              <div
                v-for="meta in lead.item_meta.offers"
                :key="meta.offer_id"
                v-tooltip="getSalesChannel(meta.saleschannel) ? getSalesChannel(meta.saleschannel).item_title : ''"
                class="flex px-2 pt-3 text-xs flex-nowrap"
              >
                <span>Angebot:</span>
                <span class="ml-1">
                  <a
                    :href="'/offer/' + meta.offer_id"
                  >
                    {{ meta.offer_id }}
                  </a>
                </span>
              </div>
              <template v-if="Array.isArray(lead.item_meta.carData)">
                <div
                  v-for="meta in lead.item_meta.carData"
                  :key="meta.carId"
                  class="flex px-2 pt-3 text-xs flex-nowrap"
                >
                  <template v-if="meta.make || meta.model || meta.trimline || meta.modelRange || meta.fuel">
                    <span>Fahrzeug:</span>
                    <div
                      v-if="!meta.carId"
                      class="ml-1"
                    >
                      {{ meta.isCarReserved ? "[R]" : '' }} {{ meta.make }} {{ meta.model }} {{ meta.trimline }} {{ meta.modelRange }}{{ meta.fuel ? " | " + meta.fuel : "" }}
                      <streamline-icon
                        v-if="meta.isCarReserved"
                        v-tooltip="'Fahrzeug ist reserviert.'"
                        class="w-3 h-3 fill-current ml-1"
                        src="alert-circle"
                      />
                    </div>
                    <div
                      v-else
                      class="ml-2"
                    >
                      <a
                        class="flex"
                        :href="`/cars/${meta.carId}/home`"
                      >
                        {{ meta.isCarReserved ? "[R]" : '' }} {{ meta.make }} {{ meta.model }} {{ meta.trimline }} {{ meta.modelRange }}{{ meta.fuel ? " | " + meta.fuel : "" }}
                        <streamline-icon
                          v-if="meta.isCarReserved"
                          v-tooltip="'Fahrzeug ist reserviert.'"
                          class="w-3 h-3 fill-current ml-1"
                          src="alert-circle"
                        />
                      </a>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else>
                <div
                  v-if="lead.item_meta.carData && ((lead.item_meta.carData.make && lead.item_meta.carData.model) || lead.item_meta.carData.carId)"
                  v-tooltip="getSalesChannel(lead.item_meta.salesChannel) ? getSalesChannel(lead.item_meta.salesChannel).item_title : ''"
                  class="flex px-2 pt-3 text-xs flex-nowrap"
                >
                  <template v-if="lead.item_meta.carData.make || lead.item_meta.carData.model || lead.item_meta.carData.trimline || lead.item_meta.carData.modelRange || lead.item_meta.carData.fuel">
                    <span>Fahrzeug:</span>
                    <div
                      v-if="!lead.item_meta.carData.carId"
                      class="ml-1"
                    >
                      {{ lead.item_meta.carData.isCarReserved ? "[R]" : '' }} {{ lead.item_meta.carData.make }} {{ lead.item_meta.carData.model }} {{ lead.item_meta.carData.trimline }} {{ lead.item_meta.carData.modelRange }}{{ lead.item_meta.carData.fuel ? " | " + lead.item_meta.carData.fuel : "" }}
                      <streamline-icon
                        v-if="lead.item_meta.carData.isCarReserved"
                        v-tooltip="'Fahrzeug ist reserviert.'"
                        class="w-3 h-3 fill-current ml-1"
                        src="alert-circle"
                      />
                    </div>
                    <div
                      v-else
                      class="ml-2"
                    >
                      <a
                        class="flex"
                        :href="`/cars/${lead.item_meta.carData.carId}/home`"
                      >
                        {{ lead.item_meta.carData.isCarReserved ? "[R]" : '' }} {{ lead.item_meta.carData.make }} {{ lead.item_meta.carData.model }} {{ lead.item_meta.carData.trimline }} {{ lead.item_meta.carData.modelRange }}{{ lead.item_meta.carData.fuel ? " | " + lead.item_meta.carData.fuel : "" }}
                        <streamline-icon
                          v-if="lead.item_meta.carData.isCarReserved"
                          v-tooltip="'Fahrzeug zum Zeitpunkt der Leaderstellung reserviert.'"
                          class="w-3 h-3 fill-current ml-1"
                          src="alert-circle"
                        />
                      </a>
                    </div>
                  </template>
                </div>
              </template>
              <div
                v-if="lead.item_meta.task"
                class="flex px-2 pt-3 text-xs flex-nowrap"
              >
                <span>Aufgabe:</span>
                <div
                  class="ml-2"
                >
                  <a
                    target="_blank"
                    :href="'/tasks/dashboard/'+lead.item_meta.task"
                  >{{ lead.item_meta.task }}</a>
                </div>
              </div>
              <div
                v-for="meta in getLeadMetaFiles(lead)"
                :key="meta.id"
                class="flex px-2 pt-3 text-xs flex-nowrap"
              >
                <span>Anhang:</span>
                <span class="ml-1">
                  <a
                    v-tooltip="meta.label"
                    href="#"
                    @click="openAttachment(meta.id)"
                  >
                    <mia-streamline-icon
                      class="w-4 h-4 fill-current"
                      src="download-bottom"
                    />
                  </a>
                </span>
              </div>
            </div>
            <div
              v-if="showParentMeta || lead.item_lead_type_is_process === '1'"
              class="flex w-full -mx-2 text-sm flex-wrap"
            >
              <div
                v-for="meta in getLeadMetaOffers(lead)"
                :key="meta.offer_id"
                v-tooltip="getSalesChannel(meta.saleschannel) ? getSalesChannel(meta.saleschannel).item_title : ''"
                class="flex px-2 py-1 mx-1 my-2 text-xs flex-nowrap border rounded-full bg-gray-300"
                :class="meta.disabled ? 'opacity-20': ''"
              >
                <span>Angebot:</span>
                <span class="ml-1">
                  <a
                    :href="'/offer/' + meta.offer_id"
                  >
                    {{ meta.offer_id }}
                  </a>
                </span>
                <button
                  type="button"
                  @click="meta.disabled = (meta.disabled === undefined ? true : !meta.disabled); updateLeadMeta(lead)"
                >
                  <mia-streamline-icon
                    class="ml-1 w-3 h-3 fill-current"
                    src="remove"
                  />
                </button>
              </div>
              <div
                v-for="meta in getLeadMetaCarData(lead)"
                :key="meta.carId"
                v-tooltip="getSalesChannel(lead.item_meta.salesChannel) ? getSalesChannel(lead.item_meta.salesChannel).item_title : ''"
                class="flex px-2 py-1 mx-1 my-2 text-xs flex-nowrap border rounded-full bg-gray-300"
                :class="meta.disabled ? 'opacity-20': ''"
              >
                <template v-if="meta.make || meta.model || meta.trimline || meta.modelRange || meta.fuel">
                  <span>Fahrzeug:</span>
                  <div
                    v-if="!meta.carId"
                    class="ml-1"
                  >
                    {{ meta.make }} {{ meta.model }} {{ meta.trimline }} {{ meta.modelRange }}{{ meta.fuel ? " | " + meta.fuel : "" }}
                  </div>
                  <div
                    v-else
                    class="ml-2"
                  >
                    <a
                      :href="`/cars/${meta.carId}/home`"
                    >{{ meta.make }} {{ meta.model }} {{ meta.trimline }} {{ meta.modelRange }}{{ meta.fuel ? " | " + meta.fuel : "" }}</a>
                  </div>
                  <button
                    type="button"
                    @click="meta.disabled = (meta.disabled === undefined ? true : !meta.disabled); updateLeadMeta(lead)"
                  >
                    <mia-streamline-icon
                      class="ml-1 w-3 h-3 fill-current"
                      src="remove"
                    />
                  </button>
                </template>
              </div>
              <div
                v-for="meta in getLeadMetaTasks(lead)"
                :key="meta"
                class="flex px-2 py-1 mx-1 my-2 text-xs flex-nowrap border rounded-full bg-gray-300"
                :class="meta.disabled ? 'opacity-20': ''"
              >
                <span>Aufgabe:</span>
                <div
                  class="ml-2"
                >
                  <a
                    target="_blank"
                    :href="'/tasks/dashboard/'+meta"
                  >{{ meta }}</a>
                </div>
                <button
                  type="button"
                  @click="meta.disabled = (meta.disabled === undefined ? true : !meta.disabled); updateLeadMeta(lead)"
                >
                  <mia-streamline-icon
                    class="ml-1 w-3 h-3 fill-current"
                    src="remove"
                  />
                </button>
              </div>
              <div
                v-for="meta in getLeadMetaFilesWithParent(lead)"
                :key="meta.id"
                class="flex px-2 py-1 mx-1 my-2 text-xs flex-nowrap border rounded-full bg-gray-300"
                :class="meta.disabled === true ? 'opacity-20': ''"
              >
                <span>Anhang:</span>
                <span class="ml-1">
                  <a
                    v-tooltip="meta.label"
                    href="#"
                    @click="openAttachment(meta.id)"
                  >
                    <mia-streamline-icon
                      class="w-4 h-4 fill-current"
                      src="download-bottom"
                    />
                  </a>
                </span>
                <button
                  type="button"
                  @click="meta.disabled = (meta.disabled === undefined ? true : !meta.disabled); updateLeadMeta(lead)"
                >
                  <mia-streamline-icon
                    class="ml-1 w-3 h-3 fill-current"
                    src="remove"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </mia-timeline-item>
    </component>
    <mia-modal
      v-if="showConversionModal"
      id="choose-process-modal"
      :click-to-close="false"
      @closed="onCancelProcessSelection"
    >
      <mia-modal-header>
        Vorgang umwandeln
      </mia-modal-header>

      <div class="p-4">
        <template v-if="leadToConvert.item_lead_type_is_process === '0'">
          <p>
            Bitte wählen Sie den Vorgangstyp aus, dem der Lead zugeordnet werden soll.
          </p>

          <mia-select
            v-model="conversionLeadType"
            class="w-full"
          >
            <option value="">
              Vorgangstyp auswählen
            </option>
            <option
              v-for="leadType in leadTypes.filter(item => item.item_is_process === '1')"
              :key="leadType.id"
              :value="leadType.id"
            >
              {{ leadType.item_title }}
            </option>
          </mia-select>
        </template>
        <template
          v-else
        >
          <p>
            Möchten SIe den Vorgang in einen Lead umwandeln?
          </p>
        </template>
      </div>

      <mia-modal-footer>
        <div class="flex justify-between w-full">
          <div class="space-x-4">
            <mia-button
              class="px-4 py-2 text-white transition-colors duration-150 bg-green-600 hover:bg-green-700 ease-out-fast"
              type="button"
              @click="onChooseConvertLead"
            >
              Umwandeln
            </mia-button>
          </div>

          <div class="flex justify-end">
            <mia-button
              class="px-4 py-2 transition-colors duration-150 hover:bg-gray-400 ease-out-fast"
              type="button"
              @click="onCancelProcessSelection"
            >
              Abbrechen
            </mia-button>
          </div>
        </div>
      </mia-modal-footer>
    </mia-modal>
    <mia-modal
      v-if="showEditModal"
      id="edit-node-modal"
      :click-to-close="false"
      @closed="disableEdit"
    >
      <mia-modal-header>
        Eintrag bearbeiten
      </mia-modal-header>

      <div class="p-4">
        <template v-if="editLead">
          <div class="flex-1 min-w-0">
            <div class="flex justify-between">
              <div class="w-full max-w-xs">
                <div class="mb-3 text-sm">
                  <label class="mb-1 mr-2 tracking-wider text-gray-800">
                    Zuweisen an
                  </label>
                  <mia-lazy-select
                    v-if="selectedUser"
                    ref="userSelectRef"
                    v-model="selectedUser"
                    :label="(value) => value.label"
                    name="item_user_id"
                    :options="searchUserResults"
                    class="w-full max-w-sm"
                    @search="searchUser"
                  />
                </div>
                <div
                  v-if="editLead.item_lead_type_is_process === '1'"
                  class="text-sm"
                >
                  <label class="mb-1 mr-2 tracking-wider text-gray-800">
                    Vorgang Titel
                  </label>
                  <mia-feature-input
                    v-model="editLead.item_alt_title"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="editLead.item_lead_type_is_custom_sleeptime === '1'"
              class="mt-2 text-sm text-gray-700"
            >
              <mia-feature-input
                v-model="editLead.item_custom_sleeptime"
                label="Warten bis"
                type="datetime-local"
              />
            </div>
            <div class="mt-2 text-sm text-gray-700">
              <mia-feature-textarea
                v-model="editLead.item_note"
                :disabled="editLead.item_lead_type_is_commentable === '0'"
                label="Notiz"
                class="mt-4"
              />
            </div>
            <div class="w-full mt-4">
              <mia-file-input
                v-model="attachmentFile"
                label="Anhang"
                accept=".pdf"
                multiple
              />
            </div>
            <hr>
            <div
              v-if="editLead.item_meta && editLead.item_meta.files"
              class=""
            >
              <div
                v-for="meta in editLead.item_meta.files"
                :key="meta.id"
                class="flex px-2 pt-3 flex-nowrap"
              >
                <span>Anhang:</span>
                <span class="flex items-center ml-1">
                  <a
                    href="#"
                    @click="openAttachment(meta.id)"
                  >
                    {{ meta.label }}
                  </a>
                  <button
                    class="flex items-center justify-center w-4 h-4 ml-3 text-red-600"
                    @click="deleteAttachment(meta.id)"
                  >
                    <i class="fa fa-trash-o" />
                  </button>
                </span>
              </div>
            </div>
          </div>
        </template>
      </div>

      <mia-modal-footer>
        <div class="flex justify-between w-full">
          <div class="space-x-4">
            <mia-button
              class="px-4 py-2 text-white transition-colors duration-150 bg-green-600 hover:bg-green-700 ease-out-fast"
              type="button"
              @click="onEditLead"
            >
              Speichern
            </mia-button>
          </div>

          <div class="flex justify-end">
            <mia-button
              class="px-4 py-2 transition-colors duration-150 hover:bg-gray-400 ease-out-fast"
              type="button"
              @click="disableEdit"
            >
              Abbrechen
            </mia-button>
          </div>
        </div>
      </mia-modal-footer>
    </mia-modal>
    <mia-confirmation-modal
      v-if="isConfirmModalVisible"
      id="confirm-delete-request-modal"
      title="Lead Löschanfrage"
      confirm-text="Lead Löschanfrage senden"
      cancel-text="Abbrechen"
      confirm-classes="border-red-600 text-red-600 hover:bg-red-600 hover:text-white"
      @confirm="deleteLead"
      @cancel="currentDeleteRequestLead = null; currentDeleteRequestReason = null;isConfirmModalVisible = false"
    >
      <div class="p-4 flex flex-col gap-4">
        <div class="w-full">
          Bitte geben Sie den Grund für Ihre Löschanfrage an:
        </div>
        <div class="w-full">
          <mia-feature-textarea
            v-model="currentDeleteRequestReason"
            placeholder="Grund für Ihre Löschanfrage"
          />
        </div>
      </div>
    </mia-confirmation-modal>
    <mia-confirmation-modal
      v-if="showConfirmRequestDeleteMultipleConfirmation"
      id="confirm-delete-multiple-leads-modal"
      :title="`Löschanfrage für ${multiSelection.length} gewählte${multiSelection.length === 1 ? 'n' : ''} ${multiSelection.length === 1 ? 'Lead' : 'Leads'}`"
      confirm-text="Löschanfrage senden"
      cancel-text="Abbrechen"
      :confirm-classes="`border-red-600 text-red-600 ${!currentDeleteMultipleRequestReason.trim() ? 'opacity-50 cursor-not-allowed hover:bg-transparent hover:text-red-600' : 'hover:bg-red-600 hover:text-white'}`"
      :is-confirm-disabled="!currentDeleteMultipleRequestReason.trim()"
      width="40%"
      @confirm="onConfirmRequestDeleteMultipleLeads"
      @cancel="onCancelRequestDeleteMultipleLeads"
    >
      <div class="p-4 w-full">
        <div>
          Bitte geben Sie den Grund für Ihre Löschanfrage an:
        </div>
        <div
          v-autofocus.closest="'textarea'"
          class="mt-2"
        >
          <mia-feature-textarea
            v-model="currentDeleteMultipleRequestReason"
            placeholder="Grund für Ihre Löschanfrage"
          />
        </div>
      </div>
    </mia-confirmation-modal>
    <div
      ref="intersect"
      class="h1"
    />
    <mia-datatable-action-bar
      :show="hasMultiSelection"
      :label="`${multiSelection.length} gewählte${multiSelection.length === 1 ? 'r' : ''} ${multiSelection.length === 1 ? 'Eintrag' : 'Einträge'}`"
      :loading="$wait.is('performing multi select lead action')"
      :loading-text="`${multiSelection.length} ${multiSelection.length === 1 ? 'Eintrag wird' : 'Einträge werden'} ${multiSelectAction}`"
      @cancel="onMultiSelectionCancel"
    >
      <button
        type="button"
        class="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-md text-sm focus:outline-none focus:shadow-red-700"
        @click="handleDeleteMultipleLeads"
      >
        Löschen
      </button>
    </mia-datatable-action-bar>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  deleteLead, deleteLeadWithReason, convertLead, markAsSeen, updateLead, deleteLeadAttachment, finishTaskLead, updateLeadMeta,
  deleteLeadsWithReason,
  deleteLeads
} from '@/api/leads'
import { search } from '@/api/user'
import { getLocalizedDate } from '@/helpers/utils'
import Draggable from 'vuedraggable'
import SparklingDiamond from '@/components/leads/SparklingDiamond.vue'
import TimelineItem from '@/components/ui/timeline/TimelineItem.vue'
import { DateTime } from 'luxon'
import FeatureTextarea from '@/components/cars/edit/FeatureTextarea.vue'
import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import FileInput from '@/components/ui/inputs/FileInput.vue'
import DatatableActionBar from '@/components/ui/datatable/DatatableActionBar.vue'
import StreamlineIcon from '../ui/StreamlineIcon.vue'

export default {
  components: {
    'mia-datatable-action-bar': DatatableActionBar,
    'mia-draggable': Draggable,
    'mia-timeline-item': TimelineItem,
    'mia-sparkling-diamond': SparklingDiamond,
    'mia-feature-input': FeatureInput,
    'mia-feature-textarea': FeatureTextarea,
    'mia-file-input': FileInput,
    StreamlineIcon
  },

  props: {
    toggleProcess: {
      type: Function,
      required: false,
      default() {
        return (() => {})
      }
    },
    isLeadpool: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
    isSortable: {
      type: Boolean,
      required: false,
      default() {
        return true
      }
    },
    showConversion: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
    showCustomerLink: {
      type: Boolean,
      required: false,
      default() {
        return true
      }
    },
    showParentMeta: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
    highlightedItems: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    salesChannels: {
      type: Array,
      required: false,
      default() {
        return null
      }
    },
    showNote: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
    leads: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    ignoreStateColors: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
    isTimeline: {
      type: Boolean,
      default: true
    },
    isWall: {
      type: Boolean,
      default: false
    },
    showDiamond: {
      type: Boolean,
      default: true
    },
    searchedUser: {
      type: [Number, String],
      required: false,
      default: 0
    }
  },

  data() {
    return {
      isConfirmModalVisible: false,
      currentDeleteRequestLead: null,
      currentDeleteRequestReason: '',
      observer: null,
      perPage: 20,
      currentPage: 0,
      selectedUser: null,
      searchUserResults: [],
      cancelToken: null,
      editLead: null,
      sortedLeads: [],
      showConversionModal: false,
      showEditModal: false,
      leadToConvert: null,
      conversionLeadType: null,
      attachmentFile: null,
      internalSalesChannels: [],
      showActionsMenu: null,
      multiSelection: [],
      multiSelectAction: '',
      showConfirmRequestDeleteMultipleConfirmation: false,
      currentDeleteMultipleRequestReason: ''
    }
  },

  computed: {
    ...mapGetters('lead', ['leadTypes', 'leadTypesFailed']),

    calcedLeadsForPages() {
      return this.sortedLeads.slice(0, this.perPage * this.currentPage)
    },

    hasSalesChannels() {
      return !!this.salesChannels && Array.isArray(this.salesChannels) && this.salesChannels.length > 0
    },

    availableSalesChannels() {
      if (!this.hasSalesChannels) {
        return this.internalSalesChannels
      }

      return this.salesChannels
    },

    hasMultiSelection() {
      return this.multiSelection.length > 0
    }
  },

  watch: {

    leads(leads) {
      this.sortedLeads = leads
    }
  },

  created() {
    this.observer = new IntersectionObserver(
      this.onElementObserved,
      {
        root: this.$el,
        rootMargin: '50px',
        threshold: 0
      }
    )
    if (!this.hasSalesChannels) {
      this.api.leads.salesChannels().then((response) => {
        this.internalSalesChannels = response
      })
    }
  },

  mounted() {
    this.observer.observe(this.$refs.intersect)
    this.sortedLeads = this.leads
    this.selectedUser = {
      value: null,
      label: 'Mitarbeiter auswählen'
    }
  },

  beforeDestroy() {
    this.observer.disconnect()
  },

  methods: {
    async updateLeadMeta(lead) {
      console.log(lead)
      await updateLeadMeta(lead.id, lead.item_meta)
      this.$forceUpdate()
    },

    onElementObserved(entries) {
      if (entries[0].isIntersecting) {
        this.currentPage = this.currentPage + 1
      }
    },

    toggleLeadCreate(leadType, parentLead) {
      eventBus.$emit('lead-select', { leadType, parentLead })
      this.$refs.actionButtonRef.close()
    },

    openAttachment(id) {
      window.open(`${window.baseUrl}/lead/getFile/${id}`)
    },

    async deleteAttachment(id) {
      if (confirm('Möchten Sie diesen Anhang wirklich löschen?')) {
        await deleteLeadAttachment(id)
        eventBus.$emit('lead-changed')
      }
    },

    handleConversion(lead) {
      this.showConversionModal = true
      this.leadToConvert = lead
    },

    async onChooseConvertLead() {
      await convertLead(this.leadToConvert.id, this.conversionLeadType ? this.conversionLeadType : null)
      this.onCancelProcessSelection()
      eventBus.$emit('lead-changed')
    },

    async handleFinishTaskLead(leadId) {
      await finishTaskLead(leadId)
      eventBus.$emit('lead-changed')
    },

    onCancelProcessSelection() {
      this.showConversionModal = false
      this.leadToConvert = null
    },

    getSalesChannel(id) {
      return this.availableSalesChannels.find(item => parseInt(item.id, 10) === parseInt(id, 10))
    },

    getParentProcess(id) {
      return this.leads.find(item => item.id === id) || []
    },

    getEscalationDate(lead) {
      let date = new Date()
      if (lead.item_lead_type_is_custom_sleeptime === '0') {
        date = new Date(lead.item_created_at)
      } else {
        date = new Date(lead.item_custom_sleeptime)

        if (Number.isNaN(Number(date)) && lead.item_custom_sleeptime === '0000-00-00 00:00:00') {
          date = new Date(lead.item_created_at)
        }
      }
      const escalationDate = new Date(date.getTime() + lead.item_lead_type_escalation_time * 60000)
      return getLocalizedDate(escalationDate)
    },

    enableEdit(leadId) {
      this.showEditModal = true
      let lead = this.leads.find(item => item.id === leadId)
      lead = { ...lead }
      if (lead.item_lead_type_is_custom_sleeptime === '1') { lead.item_custom_sleeptime = getLocalizedDate(lead.item_custom_sleeptime) }
      this.editLead = lead
      this.selectedUser = {
        value: lead.item_user_id,
        label: lead.item_user_id ? `${lead.item_firstname} ${lead.item_lastname}` : ''
      }
    },

    disableEdit() {
      this.showEditModal = false
      this.editLead = null
      this.selectedUser = {
        value: null,
        label: 'Mitarbeiter auswählen'
      }
    },

    async handleDeleteLead(leadId) {
      this.showActionsMenu = null

      if ((!this.isAllowed('leadadmin') && !this.isAllowed('delete_leads'))) {
        this.isConfirmModalVisible = true
        this.currentDeleteRequestLead = leadId
        return
      }

      if (confirm('Möchten Sie diesen Eintrag wirklich löschen?')) {
        await deleteLead(leadId)
        eventBus.$emit('lead-changed')
      }
    },

    async deleteLead() {
      await deleteLeadWithReason(this.currentDeleteRequestLead, this.currentDeleteRequestReason)
      this.currentDeleteRequestLead = null
      this.currentDeleteRequestReason = null
      eventBus.$emit('lead-changed')
    },

    async onEditLead() {
      const formData = new FormData()
      Object.entries(this.editLead).forEach(([key, value]) => {
        formData.set(key, value)
      })
      formData.set('item_user_id', this.selectedUser.value)
      if (this.attachmentFile) {
        for (let i = 0; i < this.attachmentFile.length; i++) {
          formData.append(`attachment_${i}`, this.attachmentFile[i])
        }
      }
      await updateLead(formData)
      this.disableEdit()
      eventBus.$emit('lead-changed')
    },

    async searchUser(value) {
      if (this.cancelToken) {
        this.cancelToken.cancel()
      }
      const { CancelToken } = window.axios
      this.cancelToken = CancelToken.source()

      const formData = new FormData()
      formData.set('query', value)
      const [error, data] = await search(formData, {
        cancelToken: this.cancelToken.token
      })
      if (data) {
        this.searchUserResults = data.users.map(item => ({ value: item.id, icon: item.item_image, label: `${item.item_firstname} ${item.item_lastname}` }))
      }
    },

    onSortChange() {
      this.$nextTick(() => {
        const sorting = this.leads.map(({ id }, index) => ({ id, index }))
        console.log(sorting)

        eventBus.$emit('sort-changed', sorting)
      })
    },

    onLeadClick(lead) {
      this.markLeadAsSeen(lead)
    },

    async markLeadAsSeen(lead) {
      this.$emit('lead-updated', {
        ...lead,
        item_seen_at: DateTime.local().toFormat('yyyy-MM-dd HH:mm:ss')
      })

      const [error, response] = await markAsSeen(lead.id)

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Der Lead konnte nicht als gelesen markiert werden']
        })

        this.$emit('lead-updated', {
          ...lead,
          item_seen_at: null
        })

        return
      }

      this.$emit('lead-updated', {
        ...lead,
        item_seen_at: response.item_seen_at
      })
    },

    shouldHighlightGreen(lead) {
      if (this.highlightedItems.includes(lead)) {
        return true
      }

      if (this.ignoreStateColors) {
        return false
      }

      return lead.item_is_done === '1' && lead.item_lead_type_is_won === '1'
    },

    shouldHighlightRed(lead) {
      if (this.ignoreStateColors) {
        return false
      }

      return lead.item_is_escalated === '1' || (lead.item_is_done === '1' && lead.item_lead_type_is_won !== '1' && lead.item_lead_type_is_won !== null)
    },

    getLeadMeta(lead) {
      return this.showParentMeta ? lead.item_parent_meta : lead.item_meta
    },

    getLeadMetaOffers(lead) {
      const meta = this.getLeadMeta(lead)

      if (!meta) {
        return []
      }

      return meta.offers || []
    },

    getLeadMetaCarData(lead) {
      const meta = this.getLeadMeta(lead)

      if (!meta) {
        return []
      }

      return meta.carData || []
    },

    getLeadMetaTasks(lead) {
      const meta = this.getLeadMeta(lead)

      if (!meta) {
        return []
      }

      return meta.task || []
    },

    getLeadMetaFiles(lead) {
      const meta = lead.item_meta

      if (!meta) {
        return []
      }

      return meta.files || []
    },

    getLeadMetaFilesWithParent(lead) {
      const meta = this.getLeadMeta(lead)

      if (!meta) {
        return []
      }

      return meta.files || []
    },

    startMultiSelection(lead) {
      this.addToMultiSelection(lead)
      this.showActionsMenu = null
    },

    addToMultiSelection(lead) {
      this.multiSelection = [...this.multiSelection, lead.id]
    },

    removeFromMultiSelection(lead) {
      this.multiSelection = this.multiSelection.filter(leadId => leadId !== lead.id)
    },

    toggleMultiSelection(lead) {
      if (this.multiSelection.includes(lead.id)) {
        this.removeFromMultiSelection(lead)
      } else {
        this.addToMultiSelection(lead)
      }
    },

    cancelMultiSelection() {
      this.resetMultiSelection()
    },

    resetMultiSelection() {
      this.multiSelection = []
      this.multiSelectAction = ''
    },

    onMultiSelectionCancel() {
      this.cancelMultiSelection()
    },

    async onConfirmRequestDeleteMultipleLeads() {
      if (this.$wait.is('performing multi select lead action')) {
        return
      }

      this.showConfirmRequestDeleteMultipleConfirmation = false

      this.multiSelectAction = 'gelöscht'
      this.$wait.start('performing multi select lead action')
      const [[error]] = await Promise.all([
        deleteLeadsWithReason({
          item_lead_ids: this.multiSelection,
          item_reason: this.currentDeleteMultipleRequestReason
        }),
        new Promise((resolve) => {
          window.setTimeout(resolve, 2000)
        })
      ])
      this.$wait.end('performing multi select lead action')
      this.multiSelectAction = ''

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Die Leads konnten nicht gelöscht werden']
        })
        return
      }

      window.eventBus.$emit('mia-info', {
        info: [`Die Löschanfrage für ${this.multiSelection.length} Lead${this.multiSelection.length === 1 ? '' : 's'} wurde erfolgreich erstellt`]
      })
      eventBus.$emit('lead-changed')
      this.currentDeleteMultipleRequestReason = ''
      this.resetMultiSelection()
    },

    onCancelRequestDeleteMultipleLeads() {
      this.resetRequestDeleteMultipleLeads()
    },

    resetRequestDeleteMultipleLeads() {
      this.currentDeleteMultipleRequestReason = ''
      this.showConfirmRequestDeleteMultipleConfirmation = false
    },

    async handleDeleteMultipleLeads() {
      if (this.$wait.is('performing multi select lead action')) {
        return
      }

      if (!this.isAllowed('leadadmin') && !this.isAllowed('delete_leads')) {
        this.showConfirmRequestDeleteMultipleConfirmation = true
        return
      }

      this.multiSelectAction = 'gelöscht'
      this.$wait.start('performing multi select lead action')
      const [[error]] = await Promise.all([
        deleteLeads({
          item_lead_ids: this.multiSelection
        }),
        new Promise((resolve) => {
          window.setTimeout(resolve, 2000)
        })
      ])
      this.$wait.end('performing multi select lead action')
      this.multiSelectAction = ''

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Die Leads konnten nicht gelöscht werden']
        })
        return
      }

      window.eventBus.$emit('mia-info', {
        info: [`${this.multiSelection.length} Lead${this.multiSelection.length === 1 ? '' : 's'} wurde${this.multiSelection.length === 1 ? '' : 'n'} erfolgreich gelöscht`]
      })
      eventBus.$emit('lead-changed')
      this.resetMultiSelection()
    }
  }
}

</script>

<style lang="scss" scoped>
.historyNode {
  .leadTypeTag {
    white-space: nowrap;
  }
}
</style>
